export default __webpack_public_path__ + "static/media/item8.2eab0e7c.jpg";